import React from 'react'
import ClearIcon from '@mui/icons-material/Clear'
import EditIcon from '@mui/icons-material/Edit'
import SaveIcon from '@mui/icons-material/Save'

import {
  cypressCancelButton,
  cypressEditButton,
  cypressSaveButton,
} from 'constants/cypress'

import { colors } from 'styles/theme'

import { StyledIcon } from '../style'

type EditButtonsProps = {
  editDisabled?: boolean
  edit: boolean
  disabled?: boolean
  handleEdit: () => void
  handleCancelEdit: () => void
}

const EditButtons = ({
  edit,
  handleEdit,
  disabled,
  editDisabled,
  handleCancelEdit,
}: EditButtonsProps) => {
  if (editDisabled) return null

  return !edit ? (
    <StyledIcon
      disabled={disabled}
      onClick={handleEdit}
      data-cy={cypressEditButton}
    >
      <EditIcon sx={{ color: colors.placeholderGray, fontSize: 16 }} />
    </StyledIcon>
  ) : (
    <>
      <StyledIcon
        onClick={handleEdit}
        sx={{ right: '50px !important' }}
        data-cy={cypressSaveButton}
      >
        <SaveIcon sx={{ color: colors.placeholderGray, fontSize: 16 }} />
      </StyledIcon>
      <StyledIcon onClick={handleCancelEdit} data-cy={cypressCancelButton}>
        <ClearIcon sx={{ color: colors.placeholderGray, fontSize: 16 }} />
      </StyledIcon>
    </>
  )
}

export default EditButtons
